import { confirmModalKey } from './confirm-modal.comp';
export var createConfirmModalDriver = function (wrapper) {
    var base = wrapper.$("." + confirmModalKey);
    return {
        text: function () { return base.$('.title').text(); },
        confirm: function () { return base.$('.confirm').click(); },
        cancel: function () { return base.$('.cancel').click(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map